// extracted by mini-css-extract-plugin
module.exports = {"toHome":"ToHome_toHome__2MbSo"};